module.exports = __webpack_public_path__ + "static/media/img_3.f6a0993b.png";